<div class="tds-container">
    <div class="tds-row tds-gap">
        <!-- Left side -->
        <div class="tds-col-max-4"> 
            <tds-block>
                <div class="tds-row">
                    <div class="tds-col-max-6">
                        <tds-dropdown 
                            name="dropdown" 
                            label="Region" 
                            label-position="outside" 
                            size="sm" 
                            open-direction="auto"/>
                    </div>
                    <div class="tds-col-max-6">
                        <tds-dropdown 
                            name="dropdown" 
                            label="Status" 
                            label-position="outside" 
                            size="sm" 
                            open-direction="auto"/>
                    </div>
                </div>
                <div class="tds-row">
                    <div class="tds-col-max-6">
                        <tds-datetime 
                            size="sm"
                            type="date" 
                            label="Date Started" 
                            min="2023-01-01" 
                        ></tds-datetime> 
                    </div>
                    <div class="tds-col-max-6">
                        <tds-datetime
                            size="sm" 
                            type="date" 
                            label="Date Finished"  
                            min="2023-01-01" 
                        ></tds-datetime>
                    </div>
                </div>
                <div class="tds-row">
                    <div class="tds-col-max-12">
                        <tds-text-field
                            modeVariant="secundary"
                            type="Text" 
                            size="lg" 
                            label="Description" 
                            label-position="no-label" 
                            max-length="300"
                            placeholder="Description"  
                        ></tds-text-field>
                    </div>
                </div>
                <div class="tds-row">
                    <div class="tds-col-max-2">
                        <div modal-actions class="btn-actions">
                            <tds-button size="sm" text="Search"></tds-button>
                            <tds-button size="sm" text="Reset" data-dismiss-modal></tds-button>
                            <tds-button id="open-modal-btn" (click)="show()" size="sm">
                                <tds-icon slot="icon" size="15px" name="plus"></tds-icon> 
                            </tds-button>
                        </div> 
                    </div>
                </div>

                <tds-block mode-variant="primary">
                    <div class="card-container">
                        <div class="card-list">
                            <mat-card class="card" *ngFor="let card of activityList">
                                <mat-card-content>
                                <div class="card-body-row">
                                    <div class="card-body">
                                        <div class="card-row two-columns">
                                            <div class="left-info">
                                                <span class="label">Request ID:</span>
                                                <span class="value">{{ card.id }}</span>
                                            </div>
                                            <div class="right-info">
                                                <tds-icon slot="calendar" size="20px" name="calendar" class="icon-spacing-right"></tds-icon> 
                                                <span class="value">{{ card.targetDate }}</span>
                                            </div>
                                            
                                        </div>
                                        <div class="card-row">
                                        <span class="label">Status:</span>
                                        <span class="value">{{ card.status }}</span>
                                        </div>
                                        <div class="card-row">
                                            <span class="value">{{ card.activityName }}</span>
                                        </div>
                                    </div>
                                    <div class="card-actions">
                                        <button class="icon-button" (click)="card.id !== null && showId(card.id)">
                                            <tds-icon name="chevron_right" size="20px"></tds-icon>
                                        </button>
                                    </div>
                                </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                        
                        <mat-paginator
                            [length]="totalItems"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="[5, 10, 20]"
                            (page)="onPageChange($event)">
                        </mat-paginator>
                    </div>
                </tds-block>
            </tds-block>
        </div>
        
        <form [formGroup]="form" (ngSubmit)="save()" style="display: contents">
            <!-- Right side -->
            <div class="tds-col-max-7" *ngIf="showDetails">
                <tds-block mode-variant="secundary">
                    <div>
                        <div class="tds-row gap-md">
                            <div class="tds-col-max-3">
                                <tds-text-field 
                                    type="Text" 
                                    size="sm" 
                                    label="ActivityName" 
                                    label-position="outside"
                                    [(ngModel)]="activity.activityName"
                                    formControlName="activityName"
                                    [state]="form.controls['activityName'].invalid && form.controls['activityName'].touched ? 'error' : ''"
                                    [helper]="form.controls['activityName'].invalid && form.controls['activityName'].touched ? 'invalid field' : ''"  
                                />
                            </div>
                            <div class="tds-col-max-3">
                                <tds-text-field 
                                    type="Text" 
                                    size="sm" 
                                    label="Chassis Number" 
                                    label-position="outside"
                                    [(ngModel)]="activity.chassisNumber"
                                    formControlName="chassisNumber"
                                    [state]="form.controls['chassisNumber'].invalid && form.controls['chassisNumber'].touched ? 'error' : ''"
                                    [helper]="form.controls['chassisNumber'].invalid && form.controls['chassisNumber'].touched ? 'invalid field' : ''"  
                                />
                            </div>
                            <div class="tds-col-max-2">
                                <tds-dropdown
                                    name="dropdown"
                                    label="Priority"
                                    label-position="outside"
                                    placeholder="Select"
                                    size="sm"
                                    animation="slide"
                                    open-direction="auto"
                                    [(ngModel)]="activity.idPriority"
                                    formControlName="priority"
                                    [error]="form.controls['priority'].invalid && form.controls['priority'].touched"
                                    [helper]="form.controls['priority'].invalid && form.controls['priority'].touched ? 'invalid field' : ''"  
                                >
                                    <tds-dropdown-option 
                                        *ngFor="let option of prioritys" 
                                        [value]="option.id">
                                        {{ option.priority }}
                                    </tds-dropdown-option>
                                </tds-dropdown>
                            </div>
                        </div>
                        <div class="tds-row gap-md">
                            <div class="tds-col-max-3">
                                <tds-dropdown
                                    name="dropdown"
                                    label="Region"
                                    label-position="outside"
                                    placeholder="Select"
                                    size="sm"
                                    animation="slide"
                                    open-direction="auto"
                                    [(ngModel)]="activity.idRegion"
                                    formControlName="region"
                                    [error]="form.controls['region'].invalid && form.controls['region'].touched"
                                    [helper]="form.controls['region'].invalid && form.controls['region'].touched ? 'invalid field' : ''"  
                                >
                                    <tds-dropdown-option 
                                        *ngFor="let option of regions" 
                                        [value]="option.id">
                                        {{ option.region }}
                                    </tds-dropdown-option>
                                    
                                </tds-dropdown>
                            </div>
                            <div class="tds-col-max-3">
                                <tds-dropdown
                                    name="dropdown"
                                    label="Status"
                                    label-position="outside"
                                    placeholder="Select"
                                    size="sm"
                                    animation="slide"
                                    open-direction="auto"
                                    [(ngModel)]="activity.status"
                                    formControlName="status"
                                    [error]="form.controls['status'].invalid && form.controls['status'].touched"
                                    [helper]="form.controls['status'].invalid && form.controls['status'].touched ? 'invalid field' : ''"  
                                >
                                    <tds-dropdown-option 
                                        *ngFor="let option of status" 
                                        [value]="option.status">
                                        {{ option.status }}
                                    </tds-dropdown-option>
                                    
                                </tds-dropdown>
                            </div>
                            <div class="tds-col-max-3">
                                <tds-dropdown
                                    name="dropdown"
                                    label="Responsible"
                                    label-position="outside"
                                    placeholder="Select"
                                    size="sm"
                                    animation="slide"
                                    open-direction="auto"
                                    [(ngModel)]="activity.idResponsible"
                                    formControlName="responsible"
                                    [error]="form.controls['responsible'].invalid && form.controls['responsible'].touched"
                                    [helper]="form.controls['responsible'].invalid && form.controls['responsible'].touched ? 'invalid field' : ''"  
                                >
                                    <tds-dropdown-option 
                                        *ngFor="let option of responsibles" 
                                        [value]="option.id">
                                        {{ option.responsible }}
                                    </tds-dropdown-option>
                                    
                                </tds-dropdown>
                            </div>
                        </div>
                        <div class="tds-row gap-md">
                            <div class="tds-col-max-4">
                                <tds-datetime 
                                    size="sm"
                                    type="date" 
                                    label="Target Date" 
                                    min="2023-01-01"
                                    [(ngModel)]="activity.targetDate"
                                    formControlName="targetDate"
                                    [state]="form.controls['targetDate'].invalid && form.controls['targetDate'].touched ? 'error' : ''"
                                    [helper]="form.controls['targetDate'].invalid && form.controls['targetDate'].touched ? 'invalid field' : ''"  
                                />
                            </div>
                            <div class="tds-col-max-6">
                                <tds-dropdown
                                    name="dropdown"
                                    label="Classification"
                                    label-position="outside"
                                    placeholder="Select"
                                    size="sm"
                                    animation="slide"
                                    open-direction="auto"
                                    [(ngModel)]="activity.idClassification"
                                    formControlName="classification"
                                    [error]="form.controls['classification'].invalid && form.controls['classification'].touched"
                                    [helper]="form.controls['classification'].invalid && form.controls['classification'].touched ? 'invalid field' : ''"  
                                >
                                    <tds-dropdown-option 
                                        *ngFor="let option of classifications" 
                                        [value]="option.id">
                                        {{ option.classification }}
                                    </tds-dropdown-option>
                                    
                                </tds-dropdown>
                            </div>
                        </div>
                        <div class="tds-row gap-md">
                            <div class="tds-col-max-4">
                                <tds-textarea 
                                    rows="5" 
                                    label="Notes" 
                                    label-position="outside"
                                    [(ngModel)]="activity.notes"
                                    formControlName="notes"
                                    [state]="form.controls['notes'].invalid && form.controls['notes'].touched ? 'error' : ''"
                                    [helper]="form.controls['notes'].invalid && form.controls['notes'].touched ? 'invalid field' : ''" 
                                />
                            </div>
                            <div class="tds-col-max-6">
                                <div class="tds-row">
                                    <div class="tds-col-max-12">
                                        <tds-datetime 
                                            size="sm"
                                            type="date" 
                                            label="Closed Date & Time" 
                                            min="2023-01-01" 
                                            [(ngModel)]="activity.closedDate"
                                            formControlName="closedDate"
                                            [state]="form.controls['closedDate'].invalid && form.controls['closedDate'].touched ? 'error' : ''"
                                            [helper]="form.controls['closedDate'].invalid && form.controls['closedDate'].touched ? 'invalid field' : ''"  
                                        />
                                    </div>
                                </div>
                                <div class="tds-row">
                                    <div class="tds-col-max-12">
                                        <tds-datetime 
                                            size="sm"
                                            type="date" 
                                            label="Last Update & Date" 
                                            min="2023-01-01"
                                            [(ngModel)]="activity.lastUpdateDate"
                                            formControlName="lastUpdateDate"
                                            [state]="form.controls['lastUpdateDate'].invalid && form.controls['lastUpdateDate'].touched ? 'error' : ''"
                                            [helper]="form.controls['lastUpdateDate'].invalid && form.controls['lastUpdateDate'].touched ? 'invalid field' : ''"  
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="tds-row gap-md">
                            <div class="tds-col-max-4">
                                <tds-text-field 
                                    type="Text" 
                                    size="sm" 
                                    label="Department" 
                                    label-position="outside" 
                                    [(ngModel)]="activity.department"
                                    formControlName="department"
                                    [state]="form.controls['department'].invalid && form.controls['department'].touched ? 'error' : ''"
                                    [helper]="form.controls['department'].invalid && form.controls['department'].touched ? 'invalid field' : ''"    
                                />
                            </div>
                            <div class="tds-col-max-6">
                                <tds-text-field 
                                    type="Text" 
                                    size="sm" 
                                    label="Assigned by" 
                                    label-position="outside"
                                    [(ngModel)]="activity.assignedBy"
                                    formControlName="assignedBy"
                                    [state]="form.controls['assignedBy'].invalid && form.controls['assignedBy'].touched ? 'error' : ''"
                                    [helper]="form.controls['assignedBy'].invalid && form.controls['assignedBy'].touched ? 'invalid field' : ''"   
                                />
                            </div>
                        </div>
                        <div modal-actions class="modal-actions">
                            <tds-button size="sm" text="Save" type="submit"></tds-button>
                            <tds-button size="sm" text="Cancel" data-dismiss-modal (click)="resetForm()"></tds-button>
                        </div>
                    </div>
                </tds-block>
                
            </div>
        </form>
    </div>


    
</div>